export const newsList = [
  {
    id: "1",
    title: "《苍穹之翼》第二季正式定档，天空冒险再启航",
    category: "新番资讯",
    date: "2024-10-10",
    author: "编辑部 · 星野",
    cover: "https://readdy.ai/api/search-image?query=anime%20news%20banner%20featuring%20a%20young%20pilot%20and%20airships%20above%20golden%20clouds%2C%20warm%20orange%20cinematic%20tones%2C%20dynamic%20editorial%20key%20visual&width=800&height=450&seq=news-cover-01&orientation=landscape",
    summary: "广受好评的热血冒险番《苍穹之翼》官宣第二季定档，原班制作团队回归，并公布了全新先导视觉图。",
    content: [
      "备受观众喜爱的热血冒险动画《苍穹之翼》正式宣布第二季制作完成，并公开了全新的主视觉图与首支预告片。第二季将继续由原班人马操刀，主人公凌风与他的伙伴们将飞向更辽阔的云海。",
      "制作组透露，本季在作画与分镜上投入了更多资源，尤其是空战场面将呈现前所未有的速度感与压迫感。「我们想让大家重新体会到第一次抬头看天空的那种悸动。」导演在采访中这样表示。",
      "此外，官方还公开了两位新角色的设定稿，她们将在剧情中段登场，并对主角团队产生重要影响。目前第二季的具体播出时间已进入最终确认阶段，更多情报将在下月的特别直播中公布。",
      "对于一直等待的粉丝来说，这无疑是一个振奋的消息。相关周边与联动企划也将同步启动，官方表示希望把「苍穹之翼」的世界观带给更多观众。",
    ],
    relatedIds: ["2", "4", "7"],
  },
  {
    id: "2",
    title: "本季新番整体表现盘点：哪部作品真正打动了观众",
    category: "作品评测",
    date: "2024-10-08",
    author: "评测组 · 林澈",
    cover: "https://readdy.ai/api/search-image?query=anime%20review%20banner%20with%20a%20grid%20of%20stylized%20posters%20and%20a%20score%20meter%2C%20warm%20orange%20and%20cream%20editorial%20tones&width=800&height=450&seq=news-cover-02&orientation=landscape",
    summary: "本季新番类型多元，从王道热血到细腻治愈，我们盘点了口碑与热度兼具的几部代表作。",
    content: [
      "随着本季新番陆续播出过半，各大平台的讨论热度逐渐明朗。与往季相比，本季最大的特点在于题材的多元化——既有扎实的王道热血，也有不少专注于情感与日常的细腻作品。",
      "从观众反馈来看，制作稳定、节奏得当的作品更容易积累口碑。几部主打「慢热」的治愈番凭借扎实的角色塑造，在中期实现了热度的明显回升，成为本季的意外之喜。",
      "另一方面，部分前期宣传声势浩大的作品，由于剧情推进偏慢，评价出现了一定分化。这也说明，在如今内容高度饱和的环境下，能否持续给观众惊喜，才是决定口碑的关键。",
      "综合剧情、作画、音乐与情感表达，我们整理出本季值得一看的作品清单，供不同类型偏好的观众参考。",
    ],
    relatedIds: ["1", "5", "8"],
  },
  {
    id: "3",
    title: "行业观察：国产动画出海步伐加快，海外市场表现亮眼",
    category: "行业动态",
    date: "2024-10-06",
    author: "行业组 · 陈屿",
    cover: "https://readdy.ai/api/search-image?query=anime%20industry%20banner%20showing%20a%20globe%20with%20glowing%20connection%20lines%20and%20film%20reels%2C%20warm%20orange%20and%20neutral%20tones%2C%20editorial%20graphic&width=800&height=450&seq=news-cover-03&orientation=landscape",
    summary: "近年国产动画在海外平台的表现稳步提升，题材多元化与制作水准提高成为主要推动力。",
    content: [
      "近一年来，国产动画在海外主流平台的上线数量与观看数据均呈现明显增长。业内人士认为，制作水准的整体提升与题材的多元化，是国产动画获得海外观众认可的重要原因。",
      "与传统认知不同，海外观众对国产动画的关注点并不局限于武侠或奇幻题材。一些聚焦都市生活、青春成长的作品同样收获了不错的口碑，显示出跨文化叙事的潜力。",
      "与此同时，配音本地化、字幕质量与发行节奏，仍是影响出海效果的关键环节。多位从业者表示，只有把内容做好、把细节做扎实，才能真正在海外市场站稳脚跟。",
      "可以预见，随着更多优质作品走向国际，国产动画的全球影响力还将持续扩大。",
    ],
    relatedIds: ["4", "6", "9"],
  },
  {
    id: "4",
    title: "《暗影猎手》最新剧情解析：封印之地的真相浮出水面",
    category: "作品评测",
    date: "2024-10-04",
    author: "解析组 · 苏晚",
    cover: "https://readdy.ai/api/search-image?query=anime%20analysis%20banner%20with%20a%20hooded%20figure%20and%20glowing%20runes%20in%20a%20dark%20alley%2C%20orange%20and%20deep%20shadow%20tones%2C%20dramatic%20editorial&width=800&height=450&seq=news-cover-04&orientation=landscape",
    summary: "最新一集中，夜阑在封印之地看到的画面，为整个世界观埋下了重要伏笔，我们逐一梳理。",
    content: [
      "最新一集的《暗影猎手》堪称本季信息量最大的一集。夜阑在封印之地短暂触及的记忆碎片，不仅解释了他身世的谜团，也让「影」的起源有了更清晰的轮廓。",
      "值得注意的是，本集反复出现的护符纹样，其实在第一集的开场镜头里就已经出现过。这种前后呼应的细节处理，显示出剧本在整体结构上的用心。",
      "此外，本集对配角的刻画也相当克制而有力。短短几个镜头，就完成了对一个旧日战友形象的补全，让角色的牺牲更具分量。",
      "随着真相逐步揭开，接下来的剧情走向让人充满期待。我们将持续跟进后续发展，并为观众带来深入解析。",
    ],
    relatedIds: ["1", "2", "10"],
  },
  {
    id: "5",
    title: "冬季同人展即将开幕，多部热门作品确定参展",
    category: "展会活动",
    date: "2024-10-02",
    author: "活动组 · 阿禾",
    cover: "https://readdy.ai/api/search-image?query=anime%20convention%20banner%20with%20festive%20lanterns%20and%20cosplay%20silhouettes%2C%20warm%20orange%20and%20cream%20festival%20tones%2C%20editorial%20graphic&width=800&height=450&seq=news-cover-05&orientation=landscape",
    summary: "本届冬季同人展规模再创新高，多部热门动画与漫画确定设立官方展区，现场活动丰富多彩。",
    content: [
      "一年一度的冬季同人展即将在本月底拉开帷幕。据主办方介绍，本届展会的展区面积与参展社团数量均创下新高，吸引了众多创作者与观众报名参与。",
      "多部热门动画与漫画已确定设立官方展区，现场将带来限定周边、主创见面会以及设定资料展示等内容。部分作品的声优也将到场与观众互动。",
      "为了提升参观体验，主办方优化了入场动线，并增加了餐饮与休息区域。由于预计人流较大，官方建议观众提前规划路线，错峰参观。",
      "对于动漫爱好者来说，这无疑是年末最值得期待的一场线下盛会。请关注官方渠道获取最新活动日程。",
    ],
    relatedIds: ["3", "6", "8"],
  },
  {
    id: "6",
    title: "漫画推荐：五部值得一口气读完的宝藏作品",
    category: "漫画推荐",
    date: "2024-09-29",
    author: "漫画组 · 叶子",
    cover: "https://readdy.ai/api/search-image?query=anime%20banner%20with%20a%20stack%20of%20colorful%20manga%20volumes%20and%20a%20cozy%20reading%20desk%2C%20warm%20orange%20and%20cream%20tones%2C%20editorial%20graphic&width=800&height=450&seq=news-cover-06&orientation=landscape",
    summary: "精选五部题材各异却同样精彩的漫画，无论你偏爱哪种类型，都能找到心动的一本。",
    content: [
      "在动画之外，漫画同样是动漫爱好者不可或缺的精神食粮。本次我们挑选了五部近年口碑出众的宝藏作品，它们题材各异，却都有着让人一口气读完的魅力。",
      "其中既有节奏紧凑、反转不断的悬疑题材，也有以细腻情感见长的成长故事。它们或许没有铺天盖地的宣传，却凭借扎实的内容积累了一批忠实读者。",
      "选择一部好漫画，往往只需要一个能打动你的瞬间。我们希望这份清单，能帮你在闲暇时光找到属于自己的那份惊喜。",
      "如果你也有私藏的好作品，欢迎通过我们的留言渠道分享，说不定下一期推荐就有你的一份。",
    ],
    relatedIds: ["2", "4", "9"],
  },
  {
    id: "7",
    title: "《星海拾光者》完结纪念：一段关于告别的温柔旅程",
    category: "作品评测",
    date: "2024-09-25",
    author: "评测组 · 林澈",
    cover: "https://readdy.ai/api/search-image?query=anime%20memorial%20banner%20with%20a%20girl%20holding%20a%20glowing%20lantern%20amid%20starlight%2C%20warm%20gold%20and%20teal%20tones%2C%20gentle%20editorial%20key%20visual&width=800&height=450&seq=news-cover-07&orientation=landscape",
    summary: "治愈系佳作《星海拾光者》正式完结，我们回顾这段关于记忆与离别的故事带来的感动。",
    content: [
      "《星海拾光者》在本周迎来了最终话。这部以「收集记忆之光」为主线的作品，用一个个温柔的小故事，讲述着关于告别与铭记的主题。",
      "全篇最动人之处，在于它从不刻意煽情，而是把情感藏在细微的日常里。一个眼神、一句没说完的话，往往比宏大的宣言更有力量。",
      "最终的结局并不圆满，却足够真实。它告诉观众，告别并不意味着遗忘，那些被认真珍惜过的时光，会以另一种方式继续发光。",
      "对于喜欢治愈题材的观众来说，《星海拾光者》是一部值得反复回味的作品。感谢它陪伴我们走过这段温柔的旅程。",
    ],
    relatedIds: ["2", "5", "6"],
  },
  {
    id: "8",
    title: "新作资讯：多部原创动画公布制作计划，题材覆盖多元",
    category: "新番资讯",
    date: "2024-09-21",
    author: "编辑部 · 星野",
    cover: "https://readdy.ai/api/search-image?query=anime%20banner%20showing%20storyboards%20and%20character%20sketches%20on%20a%20designer%20desk%2C%20warm%20orange%20and%20cream%20tones%2C%20editorial%20graphic&width=800&height=450&seq=news-cover-08&orientation=landscape",
    summary: "多家制作公司公布了未来的原创动画计划，从奇幻冒险到都市情感，题材覆盖多元。",
    content: [
      "在近期陆续举办的发布会上，多家制作公司公布了各自的原创动画计划。与改编作品相比，原创企划在题材探索上更为大胆，涵盖了奇幻冒险、都市情感、科幻悬疑等多个方向。",
      "值得注意的是，多部新作都强调了「面向成年观众」的定位，试图在叙事深度与情感表达上做出更多尝试。业内人士认为，这反映出市场对成熟向内容的关注度正在上升。",
      "这些原创企划大多仍处于早期阶段，具体档期尚未公布。不过从已释出的概念视觉来看，整体制作阵容颇具看点。",
      "我们会持续关注这些新作的最新进展，第一时间为观众带来报道。",
    ],
    relatedIds: ["1", "5", "9"],
  },
  {
    id: "9",
    title: "配音幕后：走进声优如何赋予角色灵魂",
    category: "行业动态",
    date: "2024-09-17",
    author: "行业组 · 陈屿",
    cover: "https://readdy.ai/api/search-image?query=anime%20banner%20of%20a%20recording%20studio%20with%20a%20microphone%20and%20headphones%2C%20warm%20orange%20and%20neutral%20tones%2C%20editorial%20graphic&width=800&height=450&seq=news-cover-09&orientation=landscape",
    summary: "一部动画的诞生离不开声优的演绎。本文带你了解配音工作背后的过程与故事。",
    content: [
      "对于观众而言，声优的表演往往是角色「活起来」的关键。但在成片背后，配音工作究竟是怎样进行的，很多人并不了解。",
      "通常在动画制作的中后期，声优们会根据分镜与画面进行录音。他们需要在有限的信息下，准确把握角色的情绪与性格。有时为了一个语气，会反复录制十几遍。",
      "除了技术，声优还需要与导演、音响监督反复沟通，理解作品的整体基调。这种默契的配合，往往决定了角色最终呈现的质感。",
      "正是这些幕后努力，才让屏幕上的角色有了温度与灵魂。下次看动画时，不妨也留意一下声音带来的细节。",
    ],
    relatedIds: ["3", "5", "8"],
  },
  {
    id: "10",
    title: "《时空回廊》观剧指南：看懂时间线的三个关键点",
    category: "作品评测",
    date: "2024-09-13",
    author: "解析组 · 苏晚",
    cover: "https://readdy.ai/api/search-image?query=anime%20banner%20with%20an%20endless%20mirrored%20corridor%20and%20clock%20motifs%2C%20moody%20amber%20tones%2C%20mysterious%20editorial%20graphic&width=800&height=450&seq=news-cover-10&orientation=landscape",
    summary: "烧脑悬疑新作《时空回廊》设定复杂，本文整理三个关键点，帮你理清它的时间线逻辑。",
    content: [
      "《时空回廊》自开播以来，凭借紧凑的节奏与复杂的设定收获了大量讨论。对于刚入坑的观众来说，理清它的时间线是理解剧情的第一步。",
      "首先要明确的是，作品中的「回廊」并非简单的穿越工具，它有着自己的规则与代价。每一次回溯都会留下痕迹，而这些痕迹最终会交汇成真正的谜底。",
      "其次，注意观察细节道具的反复出现——它们往往是判断当前时间点的关键线索。看似随手的一笔，可能正是伏笔。",
      "最后，不要急于下结论。这部作品最大的乐趣，就在于让观众和主角一起思考。希望这份指南能帮你在追剧时获得更好的体验。",
    ],
    relatedIds: ["4", "7", "9"],
  },
  {
    id: "11",
    title: "年度热门动画角色人气票选结果公布",
    category: "行业动态",
    date: "2024-09-09",
    author: "编辑部 · 星野",
    cover: "https://readdy.ai/api/search-image?query=anime%20banner%20with%20a%20podium%20and%20confetti%20celebrating%20popular%20characters%2C%20warm%20orange%20and%20gold%20festive%20tones%2C%20editorial%20graphic&width=800&height=450&seq=news-cover-11&orientation=landscape",
    summary: "年度角色人气票选结果出炉，多位新番主角票数接近，竞争异常激烈。",
    content: [
      "经过为期数周的投票，年度热门动画角色人气票选结果正式揭晓。本次投票共吸引大量观众参与，多个角色的票数十分接近，竞争异常激烈。",
      "从结果来看，兼具成长弧光与鲜明个性的角色更容易获得青睐。无论是热血番的主角，还是治愈番里的配角，都用各自的方式打动了观众。",
      "值得关注的是，多部新番角色首次上榜便取得不俗名次，显示出新生代作品的号召力正在提升。",
      "感谢每一位参与投票的观众。正是你们的热情，让这些角色被更多人看见。",
    ],
    relatedIds: ["1", "2", "6"],
  },
  {
    id: "12",
    title: "冬日观影清单：适合窝在被窝里看完的治愈番",
    category: "漫画推荐",
    date: "2024-09-05",
    author: "漫画组 · 叶子",
    cover: "https://readdy.ai/api/search-image?query=anime%20banner%20of%20a%20cozy%20winter%20bedroom%20with%20warm%20lamp%20and%20a%20tv%20showing%20anime%2C%20warm%20orange%20and%20cream%20tones%2C%20comforting%20editorial%20graphic&width=800&height=450&seq=news-cover-12&orientation=landscape",
    summary: "天气渐冷，最适合窝在被窝里看一部温柔的治愈番。这份冬日清单请收好。",
    content: [
      "随着气温下降，最惬意的事情莫过于窝在被窝里追一部温暖的作品。本次我们整理了一份冬日治愈番清单，希望能在寒冷的日子里给你一点温度。",
      "清单中的作品大多节奏舒缓、情感真挚，适合在睡前慢慢观看。它们不会带来强烈的刺激，却能在不经意间抚平一天的疲惫。",
      "好的治愈作品，往往像一杯热饮——不浓烈，却足够暖心。希望这份清单能陪你度过一个温柔的冬天。",
      "如果你也有心中私藏的治愈之作，欢迎留言与我们分享。",
    ],
    relatedIds: ["6", "7", "9"],
  },
];